__turbopack_context__.v({
  "activity_nav_items_left": "AnantaSubmenu-module-scss-module__PecPqq__activity_nav_items_left",
  "activity_nav_items_right_btn": "AnantaSubmenu-module-scss-module__PecPqq__activity_nav_items_right_btn",
  "activity_text": "AnantaSubmenu-module-scss-module__PecPqq__activity_text",
  "ananta_nav_child": "AnantaSubmenu-module-scss-module__PecPqq__ananta_nav_child",
});
